import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import {MenuItem} from 'primeng/api';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {APP_LANGS, COOKIE_LANG_KEY, COOKIE_LANG_VALUES} from 'src/shared/constants';
import Helpers from 'src/shared/helpers';

@Component({
  selector: 'language-switcher',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './language-switcher.component.html'
})
export class LanguageSwitcherComponent implements OnInit, OnDestroy {
  private destroyed = new Subject<any>();
  public menuItems: MenuItem[] = [];

  constructor(private transloco: TranslocoService) {}

  ngOnInit(): void {
    this.transloco.langChanges$
      .pipe(takeUntil(this.destroyed))
      .subscribe(lang => {
        this.setMenuItems();
      });
  }

  setMenuItems(): void {
    this.menuItems = [...APP_LANGS.sort().map(langCode => {
      let shortLangCode = Helpers.getShortLangCode(langCode);
      let flagLangCode = shortLangCode == "en" ? "gb" : shortLangCode;

      return {
        label: shortLangCode.toUpperCase(),
        disabled: langCode === this.transloco.getActiveLang(),
        icon: 'relative mr-3 -mt-1px ff-md fflag fflag-' + flagLangCode.toUpperCase(),
        command: () => {
          this.transloco.setActiveLang(langCode);
          Helpers.setCookie(COOKIE_LANG_KEY, COOKIE_LANG_VALUES[langCode]);
        }
      };
    })];
  }

  ngOnDestroy(): void {
    this.destroyed.next(undefined);
    this.destroyed.complete();
  }
}
